import { Box, Button, FormControl, FormGroup, FormHelperText, Input, InputLabel, OutlinedInput, Typography } from "@mui/material"
import styles from "./Auth.module.css"
import { useCallback, useState } from "react"
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom"

export default function Auth() {
    const [mail, setMail] = useState<string | null>(null)
    const [pwd, setPwd] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)

    const mailChecker: string | undefined = process.env.REACT_APP_MAIL
    const pwdChecker: string | undefined = process.env.REACT_APP_PWD
    const jwt: string | undefined = process.env.REACT_APP_JWT
    const navigate = useNavigate()

    const handleChangeMail = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        setMail(event.target.value)
    }, [mail])

    const handleChangePwd = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        setPwd(event.target.value)
    }, [pwd])

    const handleSubmit = useCallback((event: React.FormEvent) => {
        event.preventDefault()
        if (mail && pwd && mailChecker && pwdChecker && jwt) {
            if (mail === mailChecker && pwd === pwdChecker) {
                localStorage.setItem("token", jwt)
                navigate('/')
            } else {
                setError("Le mot de passe ou l'email est incorrecte")
            }
        }
    }, [mail, pwd])

    return (<>
        <h1 className={styles.h1}>Connexion</h1>
        <form className={styles.formContainer} onSubmit={handleSubmit}>
            <FormGroup>
                <FormControl>
                    <InputLabel required={true} variant="outlined" htmlFor="mail">Adresse mail</InputLabel>
                    <OutlinedInput onChange={handleChangeMail} label="Adresse mail" id="mail" aria-describedby="mail-helper"/>
                    <FormHelperText id="mail-helper">xxxx@aa.com</FormHelperText>
                </FormControl>
                <FormControl sx={{
                    margin: "20px 0 0 0"
                }}>
                    <InputLabel required={true} variant="outlined" htmlFor="pwd">Mot de passe</InputLabel>
                    <OutlinedInput onChange={handleChangePwd} label="Mot de passe" id="pwd" type="password"/>
                </FormControl>
            </FormGroup>
            {error &&
                <Typography color="error" variant="body2" sx={{
                    margin: "10px 0 0 0"
                }}>
                    {error}
                </Typography>
            }
            <Button type="submit" variant="contained" sx={{
                margin: "20px 0 0 0"
            }}>Se connecter</Button>
        </form>
    </>)
}